<div class="chart-wrapper"
     *adaptLoading="isLoading">
    <dx-chart (onInitialized)="onInitialized($event)"
              [dataSource]="timelineData"
              [series]="series"
              [pathModified]="true"
              title="Cultural Index timeline">
        <dxo-chart-common-series-settings argumentField="date"
                                          type="stackedarea"> </dxo-chart-common-series-settings>
        <dxo-chart-argument-axis>
            <dxo-chart-label alignment="right"
                             format="monthAndYear"
                             overlappingBehavior="rotate"
                             [rotationAngle]="-45"> </dxo-chart-label>
        </dxo-chart-argument-axis>
        <dxo-chart-legend [visible]="true"> </dxo-chart-legend>
        <dxo-chart-loading-indicator>
            <dxo-chart-font [size]="30"> </dxo-chart-font>
        </dxo-chart-loading-indicator>
        <dxo-chart-tooltip [enabled]="true"
                           [customizeTooltip]="customiseTooltip"> </dxo-chart-tooltip>
        <dxo-chart-margin [bottom]="50"> </dxo-chart-margin>
        <dxo-chart-size [height]="responsiveService.currentBreakpoint.isMobileSize ? 300 : 600"> </dxo-chart-size>
    </dx-chart>

    @if (!timelineData.length) {
        <adapt-no-cultural-measurement label="Cultural Indexes"></adapt-no-cultural-measurement>
    }
</div>
